import requestApi from "./requestApi";
import { API_CONSTANT_MAP } from "./paths";

export const getAllCategoriasProduto = async (params?: { somenteAtivas?: boolean }) => {
  let url = API_CONSTANT_MAP.categoriaProduto;
  if (params?.somenteAtivas) {
    url += "?somenteAtivas=true";
  }
  return requestApi.get(url);
};

export const getCategoriaProdutoById = async (id: string | number) => {
  return requestApi.get(`${API_CONSTANT_MAP.categoriaProduto}/${id}`);
};

export const saveCategoriaProduto = async (payload: any) => {
  return requestApi.post(API_CONSTANT_MAP.categoriaProduto, payload);
};

export const ativarDesativarCategoriaProduto = async (id: string | number, ativo: boolean) => {
  return requestApi.put(`${API_CONSTANT_MAP.categoriaProduto}/${id}/ativo`, { ativo });
};
